import { useState } from "react";
import { ProcessWrapper, OverviewWrapper, RowsWrapper } from "../../styles";
import { ApplicantInfoOverview } from "../../../../components/Applicant/ApplicantInfoOverview";
import { OverviewHeader } from "../../../../components/Header/OverviewHeader";
import { Modals } from "../modals";
import { ApplicantRow } from "../../rows/es/applicantRow";
import { ApplicationtRow } from "../../rows/es/applicationRow";
import { FinancialDeclaredRow } from "../../rows/es/financialDeclaredRow";
import { FinancialPsd2Row } from "../../rows/es/financialPsd2Row";
import { OfferDetailsRow } from "../../rows/es/offerDetailsRow";
import { CalculationRow } from "../../rows/es/calculationRow";
import { ExistingLoanDetailsRow } from "../../rows/es/existingLoanDetailsRow";

export const LoanOverviewEs = (flow: any) => {
  //States used to view modals for KYC, transactions & video ID
  const [selectedModal, setSelectedModal] = useState<string>("");

  //Variables used to display data
  const { data, flowId } = flow?.caseData || {};

  const { country, agentApiApplication: agentApi, integrations } = data || {};

  const { applicant, coapplicant } = agentApi || {};

  const { leabank } = integrations || {};
  const { ownExperience } = leabank || {};

  function handleModalClose() {
    setSelectedModal("");
  }


  return (
    <OverviewWrapper>
      <OverviewHeader country={country} label="Loan application" flow={flow} />
      <ProcessWrapper>

          <ApplicantInfoOverview applicant={applicant} coapplicant={coapplicant} />
          <RowsWrapper className="general information">
            <div className="left-side" style={{ marginRight: "10px" }}>
              <ApplicantRow data={data} />
            </div>
              <div className="right-side" style={{ marginLeft: "10px" }}>
                <ApplicationtRow data={data} flowId={flowId} setSelectedModal={setSelectedModal} />
              </div>
          </RowsWrapper>
          <RowsWrapper className='Financial information'>
            <div className="left-side" style={{ marginRight: "10px" }}>
               <FinancialDeclaredRow data={data} />
          </div>
          <div className="right-side" style={{ marginLeft: "10px" }}>
               <FinancialPsd2Row data={data} />
          </div>
          </RowsWrapper>
          <RowsWrapper className="Offer information">
            <div className="left-side" style={{ marginRight: "10px" }}>
              <OfferDetailsRow data={data} status={data?.status} />
          </div>
          <div className="right-side" style={{ marginLeft: "10px" }}>
              <CalculationRow data={data} />
          </div>
          </RowsWrapper>
          {ownExperience?.isTopUp ? <ExistingLoanDetailsRow data={data} /> : null} 

      </ProcessWrapper>
      <Modals
        flow={flow}  modalToShow={selectedModal} handleModalClose={handleModalClose}/>
    </OverviewWrapper>
  );
};

export default LoanOverviewEs;
